angular.module('aprima-bridge').factory('IosBridge',
    ['XamarinBridge', '_', function (XamarinBridge, _) {
        'use strict';

        var iosBridge = _.cloneDeep(XamarinBridge);

        //add properties unique to android here

        return iosBridge;
    }]);
